/**
 * Netaffinity
 *
 * @exports bs_190
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    const BONNINGTON_DUBLIN_PID = 1015694;
    const CLANREE_HOTEL_PID = 1015671;
    const WESTPORT_HOTEL_PID = 1027962;
    /**
       *
       * Define a function to fill the right form on the BE Rooms & Rates page.
       * The problem with this engine is that they have more than 1 input that,
       * with the actual aproach of the main `generate_promocode_handler` function
       * can't be handled. This leads us to modify and fill the specific input that
       * will be taken to apply the promocode.
       *
       * @memberOf module:bs_190
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot(ctx) {
        // Declare custom function only when the Rooms & Rates search form is available
        if (document && document.forms) {
            const bkeSearchForm = document.forms.bke_search;
            const wcrForm = document.querySelector('.wcr-form');
            thn.netaffinityApplypromo = function thnNetaffinityApplypromo(data) {
                if (bkeSearchForm) {
                    document.forms.bke_search.bke_ratecode.value = data.code;
                    document.forms.bke_search.submit();
                }
                else if (wcrForm) {
                    wcrForm.querySelector('[name=bke_ratecode]').value = data.code;
                    wcrForm.submit();
                }
            };
            thn.shutdown(() => {
                delete thn.netaffinityApplypromo;
            });
        }
        // These pids have 2 webs, 1 without subdomain web and one with subdomain web. Only in the one who has no subdomain we need to add an eventListener to change lang.
        if (!window.location.hostname.match(/(bookings|web)/)) {
            const pidsWithLangSpa = [1027371, 1027370, 1027372, 1027368, 1027369];
            if (thn.inArray(thn.data.propertyId, pidsWithLangSpa)) {
                const undelegateClickLang = thn.delegate('click', '.langList', () => {
                    setTimeout(thn.languageCheck(), 1000);
                });
                thn.shutdown(() => {
                    undelegateClickLang();
                });
            }
        }
    };
    /**
       * @memberOf module:bs_190
       *
       * @see {@link Price#get_promocode}
       *
       * @param {object} ctx - The context object.
       */
    engine.getPromocode = function getPromocode(ctx) {
        ctx.promocode = document.forms.bkeSearch
            && document.forms.bkeSearch.bkeRatecode
            && document.forms.bkeSearch.bkeRatecode.value;
        return ctx.promocode;
    };
    /**
       * @memberOf module:bs_190
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise((resolve, reject) => {
            let language;
            if (thn.data.accountUserId === 1034124) {
                resolve('en');
            }
            // Belmore Court & Motel
            if (thn.data.accountUserId === 1034134) {
                resolve('en');
            }
            // These pids have 2 webs, 1 without subdomain web and one with subdomain web. Only in the one who has no subdomain we need to wait until dom is ready to take current lang.
            if (!window.location.hostname.match(/(bookings|web)/)) {
                const pidsWithLangSpa = [1027371, 1027370, 1027372, 1027368, 1027369];
                if (thn.inArray(thn.data.propertyId, pidsWithLangSpa)) {
                    thn.domReady().then(() => {
                        language = document.querySelector('.translate.active')?.textContent.trim();
                        if (language && ctx.langs.test(language)) {
                            resolve(language);
                            return;
                        }
                        reject('no_language');
                    });
                    return;
                }
            }
            thn.domReady().then(() => {
                if (thn.data.propertyId === 1015435) {
                    language = document.querySelector('.dropdown.set-language a')?.textContent.trim().toLowerCase();
                    if (language && ctx.langs.test(language)) {
                        resolve(language);
                        return;
                    }
                }
                if (thn.data.accountUserId === 1033901) {
                    language = document.querySelector('.trp-ls-shortcode-current-language a')?.innerText;
                    if (language && ctx.langs.test(language)) {
                        resolve(language);
                        return;
                    }
                }
                language = document.querySelector("select[name='lang']")?.value;
                if (language && ctx.langs.test(language)) {
                    resolve(language);
                    return;
                }
                reject('no_language');
            });
        });
    };
    /**
       * Refresh the PW when we modifiy the filters
       * @memberOf module:bs_190
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(_ctx) {
        const roomsWrapper = document.querySelector('#bke-wrapper, #gridview-content');
        if (roomsWrapper && !thn.netaffinityPriceUpdater) {
            thn.netaffinityPriceUpdater = thn.debounce(() => {
                if (!roomsWrapper.querySelector('.loading')) {
                    thn.widgets.price.update();
                }
            }, 350);
            thn.observeDom(roomsWrapper, thn.netaffinityPriceUpdater, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style'],
            });
            thn.pageUnload(() => {
                thn.stopObserveDom(roomsWrapper, thn.netaffinityPriceUpdater);
                delete thn.netaffinityPriceUpdater;
            });
        }
    };
    /**
       * @memberOf module:bs_190
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        let widgetData = {};
        // Early exit to avoid triggering the PW outside R&R (is not possible/too difficult to change the mapping)
        if (thn.data.accountUserId === 1033901 && !thn.isVisible(document.querySelector('.na-progress-bar__main'))) {
            widgetData.noRooms = true;
            return widgetData;
        }
        // 2019-04-18: This BE has no guests dropdown selector and sometimes when going through all the rates displayed in the tables some prices may be equal but with
        // a different number of guests associated. By default we override the guests number when prices are equal and that could return a total of 4 guests if
        // these had the same price as the single rate (1 guest vs 4 guests.. poor scrapper). For the following user ids just override the guests if its number
        // is less than the one we currently have.
        const userIdSpecialGuests = [
            1033948, // McGettigan Hotels
            1036183, // Douar Samra
            1036195, // Margo Hospitality
        ];
        // Some properties wants us to override the default occupancy of the rooms
        // The client wants the default occupancy of 1 adult given rooms with 1 or 2 occupancy (room suitable for bpoth occupancies)
        const propertiesDefaultPax1 = thn.inArray(thn.data.propertyId, [
            1025513, // Douar Samra
            1027370, // Mimi Calpe
        ]);
        // Also, sometimes, the client wants us to ignore the number of children
        const propertiesDefaultPax2IgnoreChildren = thn.inArray(thn.data.propertyId, [
            1027342, // Riad Bindoo
            1027318, // Riad Massiba
            1026875, // Dar Akal
            1027321, // Dar Zelda
            1027371, // El Manzar
            1027372, // Riad Omara al Kasbah
            1027368, // Riad Azzouna 13
            1027369, // Riad Zaouia 44
            1027362, // Terra Mia
        ]);
        // Also sometimes the client wants us to ignore the best price if the room has discounted rate
        const ignoreDiscountedRooms = thn.inArray(thn.data.propertyId, [
            WESTPORT_HOTEL_PID,
        ]);
        // The hotels of this user already shows the price per night
        const usersAlreadyWithPricePerNight = thn.inArray(thn.data.accountUserId, [1038383]);
        // In some properties we need to avoid flagging it as special rates
        // the packages found before the Best Rate available
        // In the desired properties, the value has to be true
        const ignoreRateBeforeBar = thn.inArray(thn.data.accountUserId, [1036183, 1036195]) // Douar Samra, Margo Hospitality
            || thn.inArray(thn.data.propertyId, [1015351, BONNINGTON_DUBLIN_PID, CLANREE_HOTEL_PID]);
        //* Dates
        let isFlexibleDates = !!document.querySelector('#view-switch2:not([class*=off])');
        let nights;
        const arrivalYear = document.querySelector('#bke_arrival_year')?.value;
        const arrivalDay = document.querySelector('#bke_arrival_day')?.value;
        const arrivalMonth = document.querySelector('#bke_arrival_month')?.value;
        const dateBegin = arrivalDay && arrivalMonth && arrivalYear && `${arrivalYear}/${arrivalMonth}/${arrivalDay}`;
        const departureYear = document.querySelector('#bke_departure_year')?.value;
        const departureDay = document.querySelector('#bke_departure_day')?.value;
        const departureMonth = document.querySelector('#bke_departure_month')?.value;
        const dateEnd = departureDay && departureMonth && departureYear && `${departureYear}/${departureMonth}/${departureDay}`;
        if (dateBegin && dateEnd) {
            widgetData.dateBegin = dateBegin;
            widgetData.dateEnd = dateEnd;
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        //* Rooms
        widgetData.rooms = 1;
        //* Currency
        const currencySelector = (document.querySelector('#curr_selector') && document.querySelector(`#curr_selector [value="${document.querySelector('#curr_selector')?.value}"]`));
        const currencyEl = document.querySelector('.selected-curr-symbol')
            || document.querySelector('span.curr_chan.curr_data0')
            || document.querySelector('.rightprice span');
        if (currencySelector) {
            widgetData.currency = currencySelector.textContent;
        }
        else if (currencyEl && !widgetData.currency) {
            widgetData.currency = thn.getCurrencyCode((currencyEl.textContent.match(/[^\d\s,.]+/) || [])[0]);
        }
        //* Guests
        /**
            * In some cases, there's a guests "filter" that modifies the results.
            * (guests are usually taken FROM the lowest priced room)
            * We will read the selected guests first, if not in default value (default is 0, not modified).
            */
        let adultsFromSelector = 0;
        let childrenFromSelector = 0;
        const adultsEl = [...document.querySelectorAll('[for^=age_codes_]')].filter((el) => el.textContent.match(/adult/i))[0];
        const adultsElValue = adultsEl?.nextElementSibling?.value;
        adultsFromSelector = thn.parseNumber(adultsElValue) || 0;
        const childrenEl = [...document.querySelectorAll('[for^=age_codes_]')].filter((el) => el.textContent.match(/(child|infant)/i));
        const childrenNumberSelector = childrenEl.map((el) => thn.parseNumber(el.parentElement?.querySelector('.option-picker-value')?.textContent) || 0);
        const [numChild = 0, numInfant = 0] = childrenNumberSelector;
        childrenFromSelector = numChild + numInfant;
        // if the guests filter is untouched, guests will be 0, and we will take them from the lowest priced room afterwards.
        let guestsFromSelector = adultsFromSelector + childrenFromSelector;
        /**
            * The common logic used for deciding if a room is suitable is if the numer of guests that the user puts
            * in the form have to match the occupancy (maximum number of guests per room).
            * In some cases, we want to match room when the occupancy (of the room) is greater than the number of guests
            */
        const roomsMatchWhitelist = [1026630];
        let prices = [];
        let rateBeforeBar = true;
        const barExists = [...document.querySelectorAll('.special-name')].filter((rate) => rate.textContent.match(/Best Available/i)).length;
        const roomElements = [...document.querySelectorAll('.panel.room-choice, .panel.tariff')].filter((roomElem) => thn.isVisible(roomElem));
        if (roomElements.length) {
            // Get prices (and rate data)
            roomElements.forEach((room) => {
                // Ignore rooms until one is found that doesn-t have a discount badge
                if (room.querySelector('[class*=badge-discount-]') && ignoreDiscountedRooms && roomElements.length > 1) {
                    return;
                }
                isFlexibleDates = false;
                let roomRates = room.querySelectorAll('.room-list.row');
                if (!roomRates.length || isFlexibleDates) {
                    isFlexibleDates = true;
                    roomRates = room.querySelectorAll('.price-row');
                }
                // Check if the current room is Best Available Rate
                if (room.querySelector('.special-name')?.textContent?.match(/Best Available/i)) {
                    rateBeforeBar = false;
                }
                for (let i = 0; i < roomRates.length; i += 1) {
                    let price = 0;
                    let currency;
                    let priceSpecial;
                    if (isFlexibleDates) {
                        /**
                                    * The user could see rates reserved to a set number of nights
                                    * and the user could have less than the nights requiered and he/she will still se it
                                    *
                                    * We need to understand if the rate is limited to a number of nights
                                    * We can use the title, follows the following format: "Foo 2 nights bar"
                                    */
                        const requiredNightsMatch = room.querySelector('.special-name')?.textContent?.match(/(\d{1,2})\s?(night|nuit)/i);
                        // Extract the number of nights from the rate name
                        const requiredNights = requiredNightsMatch && thn.parseNumber(requiredNightsMatch[1]);
                        // Two cases:
                        //      - The rate has the number of nights present on the name -> Matches the number of nights the user searched?
                        //      - The rate hasn't the number of nights present on the name -> Nothing to be done here, all correct
                        const suitableNumberNights = requiredNights ? requiredNights === nights : true;
                        /**
                                    * From this BE, we can't obtain the price day by day if the user selects more than 8 days
                                    * (8 is the maximum number of dates that we can obtain the price)
                                    *
                                    * If the number of nights is greater than 8 we need to obtain the value from another way
                                    */
                        if (nights > 8) {
                            const priceEls = [...document.querySelectorAll('.desc.desc-list .curr_chan')].map((priceEl) => thn.parseNumber(priceEl.textContent));
                            // The price is presented per night or per stay?
                            const priceIsPerNight = thn.empty(document.querySelector('.desc.desc-list .rightprice')?.textContent?.match(/total\sstay/i));
                            if (!thn.empty(priceEls)) {
                                if (priceIsPerNight && suitableNumberNights) {
                                    price = Math.min(...priceEls);
                                }
                                else if (suitableNumberNights) {
                                    price = Math.min(...priceEls) / nights;
                                }
                                else {
                                    price = 0;
                                }
                            }
                        }
                        else {
                            // Add all the prices for the selected days (columns)
                            const priceEls = roomRates[i].querySelectorAll('.price-cell.col-selected');
                            if (priceEls.length) {
                                let daysSelected = 0;
                                priceEls.forEach((rowpriceElements) => {
                                    const rowPriceText = rowpriceElements.querySelector('span.curr_chan')?.innerText.trim()
                                        || rowpriceElements.innerText.trim()
                                        || rowpriceElements.querySelector('input.room-price')?.value;
                                    // Currency fallback
                                    if (!currency) {
                                        currency = thn.getCurrencyCode((rowPriceText.match(/[^\d\s,.]+/) || [])[0]);
                                    }
                                    daysSelected += 1;
                                    price += thn.parseNumber(rowPriceText);
                                });
                                /**
                                                * 2019-03-19: Before setting the price, check that the number of columns added is equal to the number of days selected.
                                                * That's because some rates only have 1-day availability and that'd be the cheapest price (as we only add 1 price to the total sum).
                                                */
                                price = daysSelected === nights && suitableNumberNights ? price : 0;
                            }
                        }
                    }
                    else {
                        const priceEl = roomRates[i].querySelector('.room-price b span, .room-price span b');
                        if (priceEl) {
                            // Currency fallback
                            currency = (document.querySelector('#curr_selector') && document.querySelector(`#curr_selector [value="${document.querySelector('#curr_selector')?.value}"]`)?.textContent)
                                || thn.getCurrencyCode((priceEl.textContent.match(/[^\d\s,.]+/) || [])[0]);
                            price = thn.parseNumber(priceEl.textContent);
                        }
                    }
                    if (price) {
                        if (roomElements.length === 1) {
                            // Nowdays all the rooms contain a class called special or package
                            // If there's only one room avaiable, we cannot ensure that we can see the BAR
                            priceSpecial = 1;
                        }
                        else if (room.querySelector('.special-name a, .room-choice__tariff h3')?.textContent?.match(/business|corporate/ig)) {
                            // Flag business rooms as price special
                            priceSpecial = 1;
                        }
                        else if (thn.data.accountUserId === 1034134 && room.getAttribute('data-filter')?.match(/packages1/)) {
                            // In some chains like Belmore Court, we're flagging as special rate the normal rates and the client doesn't wan't that
                            // This are the Rates
                            // - Best Available Flexible Room Only
                            // - Best Available Flexible B&B
                            // We need to avoid flaggin as special rates the rate "packages1"
                            if (thn.empty(thn.widgets.price.getPromocode().promocode)) {
                                // The flag priceSpecial= 2 for promocodes requires the priceSpecial to be undefined,
                                // so we first check that there are no promocodes
                                priceSpecial = 0;
                                if (room.getAttribute('data-filter')?.match(/specials/) && (rateBeforeBar && !ignoreRateBeforeBar && barExists)) {
                                    // In Belmount Court there are some rooms with the  attribute data-filter="packages1" that are priceSpecial.
                                    // So if they have "packages1", and "special", then we apply the flag
                                    priceSpecial = 1;
                                }
                            }
                        }
                        else if ((room.getAttribute('data-filter')?.match(/special|package/)
                            || room.closest('#specialswrapper')
                            || room.querySelector('.badge-exclusive-offer'))
                            && (rateBeforeBar && !ignoreRateBeforeBar && barExists)) {
                            // Check if the room fulfils any of the following conditions to be classified as a special rate
                            priceSpecial = 1;
                        }
                        if ([...document.querySelectorAll('#filter-offers ul li input')].filter((ele) => ele.checked).length) {
                            // If filters are applied, we should flag the search as special rate
                            priceSpecial = 1;
                        }
                        //* Guests
                        let adults = 2;
                        let children = 0;
                        // Get the guests from the icons of the room title
                        if (roomRates[i].querySelector('.roomcategory-single') || (roomRates[i].querySelector('.roomcategory-singledouble') && propertiesDefaultPax1)) {
                            adults = 1;
                        }
                        else if (roomRates[i].querySelector('.roomcategory-double, .roomcategory-singledouble')
                            || (propertiesDefaultPax2IgnoreChildren && roomRates[i].querySelector('.roomcategory-family3, .roomcategory-family4'))) {
                            adults = 2;
                        }
                        else if (roomRates[i].querySelector('.roomcategory-triple')) {
                            adults = 3;
                        }
                        else if (roomRates[i].querySelector('.roomcategory-quadruple')) {
                            adults = 4;
                        }
                        else if (roomRates[i].querySelector('.roomcategory-family3')) {
                            adults = 2;
                            children = 1;
                        }
                        else if (roomRates[i].querySelector('.roomcategory-family4')) {
                            adults = 2;
                            children = 2;
                        }
                        // For PREMIER SUITES PLUS Antwerp the BAR is usually a room with children
                        // It is even cheaper than the same room without children (less guests)
                        // We discard the children for proper price compare with OTAs
                        if (thn.data.propertyId === 1015440) {
                            children = 0;
                        }
                        // Pembroke hotel always takes the total price on their R & R page. So, we need to divide the price by the number of nights.
                        const isPembrokeHotel = thn.data.propertyId === 1015890;
                        // Check if price should be modified according to room's min rate text
                        const roomPriceInfoText = room.querySelector('.rightprice, .price-container, .room-choice__tariffrom')?.textContent;
                        if (roomPriceInfoText?.match(/total stay|per couple/i) || isPembrokeHotel) {
                            // If price is per total stay we return the price per night
                            price /= nights;
                        }
                        else if (roomPriceInfoText?.match(/person|personne|человек|adulte?/i) && adults) {
                            // if price description is per person but not "per person per night"
                            if (nights && !roomPriceInfoText?.match(/night|nuit|nacht/i) && !usersAlreadyWithPricePerNight) {
                                let guests = adults;
                                // In some properties, children counts as adults
                                if (thn.data.propertyId === 1014962) {
                                    guests += children;
                                }
                                price = (price * guests) / nights;
                            }
                        }
                        let guests = adults + children;
                        // If the property is whitelisted we should override the number of adults to satisfy the occupancy of the room
                        if (thn.inArray(thn.data.propertyId, roomsMatchWhitelist)) {
                            adultsFromSelector = adults;
                            childrenFromSelector = children;
                            guestsFromSelector = adults + children;
                        }
                        // We take currency from form selector on the first time. Later, script takes it from prices room. This items mantain $ and kr symbol for 3 or 4 currency, returning
                        // same currency for those. In those cases, reasign currency obtained from selector.
                        currency = (currency === 'USD' || currency === 'SEK') ? widgetData.currency : currency;
                        // Try to match user input (if modified) with the room guests
                        if (guests || guestsFromSelector) {
                            if (guestsFromSelector) {
                                // Reassign adults & children to match search (example: selector = "2 adults, 1 child" vs "room = 3 adults")
                                adults = (adultsFromSelector > adults) ? adultsFromSelector : adults;
                                children = childrenFromSelector;
                                guests = adults + children;
                            }
                            prices.push({
                                adults,
                                children,
                                guests,
                                currency,
                                price,
                                priceSpecial: priceSpecial,
                            });
                        }
                    }
                }
            });
            const ignoreOneAdult = [1037964].includes(thn.data.accountUserId);
            if (ignoreOneAdult && prices.length) {
                prices = prices.filter((roomInfo) => roomInfo.guests > 1);
            }
            if (!prices.length && guestsFromSelector) {
                widgetData.adults = adultsFromSelector;
                widgetData.children = childrenFromSelector;
                widgetData.guests = guestsFromSelector;
                widgetData.noRooms = true;
            }
        }
        if (prices.length) {
            const specialUserId = thn.inArray(thn.data.accountUserId, userIdSpecialGuests);
            const minPrice = prices.reduce((prev, curr) => {
                // Lowest price
                if (curr.price < prev.price) {
                    return curr;
                }
                // Same price and more guests (only if the user id is not specified in the custom array explained at the beginning)
                if (curr.price === prev.price && ((curr.guests < prev.guests && specialUserId) || (curr.guests > prev.guests && !specialUserId))) {
                    return curr;
                }
                return prev;
            });
            // If there are no specific currency in the rate, get the general currency
            if (!minPrice.currency) {
                minPrice.currency = widgetData.currency;
            }
            // Join data
            widgetData = Object.assign(widgetData, minPrice);
            widgetData.set = true;
        }
        else if (!!document.querySelector('.bke_error:not([display*=none])')
            || (!prices.length && thn.inArray(thn.data.propertyId, roomsMatchWhitelist))
            || !!document.querySelector('.no-results-message')) {
            // No rooms
            widgetData.noRooms = true;
        }
        /**
             * In Flexible Dates, when an error appears we should flag this search as no rooms
             * because we can't guarantee that the user can select all the days,
             * we need to check if there's a error message appearing and we're on Flexible Dates
             */
        if (!!document.querySelector('.bke_error:not([display*=none])') && !thn.empty(document.querySelectorAll('.panel .price-row'))) {
            // When we search for dates that doesn't satisfy the minumum number of nights, we collect all the data and we set widgetData.set as true
            // At the same time, we enter in this exception as set the PW as "no-rooms", the PW doesn't know what to do and send the status "page-refresh"
            // If we enter in this case, we need to ensure that widgetData.set is false
            // example: https://secure.motel.co.uk/bookings/checkavailability
            widgetData.set = false;
            // No rooms
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_190
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        if (!document.querySelector('.panel.confirmation')) {
            // Not recognized Booking Confirmed page
            widgetData.set = false;
            return widgetData;
        }
        if (window.dataLayer) {
            const promocode = (thn.dataLayerHelper.get('transactionPromoCode')?.split(':')[1]?.trim());
            if (promocode) {
                widgetData.promocode = promocode;
            }
        }
        const arrivalDate = document.querySelector('#confirmation-text + h2 + ul > li:nth-child(1)');
        if (arrivalDate) {
            widgetData.dateBegin = arrivalDate.textContent.substr(-10).split('.').reverse().join('/')
                .trim();
        }
        const departureDate = document.querySelector('#confirmation-text + h2 + ul > li:nth-child(2)');
        if (departureDate) {
            widgetData.dateEnd = departureDate.textContent.substr(-10).split('.').reverse().join('/')
                .trim();
        }
        let thnPrice = document.querySelector('#bke-wrapper > div > ul.list.price > li:nth-child(1)');
        if (thnPrice) {
            thnPrice = thnPrice.textContent.split(':').reverse()[0].trim();
            widgetData.price = thn.parseNumber(thnPrice);
            widgetData.currency = thn.getCurrencyCode((thnPrice.match(/[^\d\s,.]+/) || [])[0]);
        }
        const bookingId = document.querySelector('p.booking-reference span');
        if (bookingId) {
            widgetData.bookingId = bookingId.textContent;
        }
        return widgetData;
    };
    return engine;
}

export { factory };
